module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage Rtable8"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-8：人员基本情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), (_vm.role == 'show') ? _c('div', {
    staticClass: "percentTab"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.percentArr), function(term, inx) {
    return _c('tr', [(inx < 2) ? [_c('td', [_vm._v(_vm._s(_vm._f("transStr")(term.workerType, 'type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.thisWorker))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.certificateWorker))]), _vm._v(" "), (inx == 0) ? _c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("\n                          " + _vm._s((_vm.munCount && _vm.munCount.length > 0) ? _vm.munCount[0].certificateWorkerProportion : 0) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.zjCertificate))]), _vm._v(" "), (inx == 0) ? _c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s(_vm._f("pecCount")(term, _vm.percentArr, 2)))]) : _vm._e()] : [_c('td', [_vm._v(_vm._s(_vm._f("transStr")(term.workerType, 'type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.thisWorker))]), _vm._v(" "), _c('td', [_vm._v(" ———— ")]), _vm._v(" "), _c('td', [_vm._v(" ———— ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.zjCertificate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("pecCount")(term, _vm.percentArr, 3)))])]], 2)
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": function($event) {
        _vm.tabSeek('seek')
      }
    },
    model: {
      value: (_vm.seekPms.type),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "type", $$v)
      },
      expression: "seekPms.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过姓名、身份证号、手机号查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('seek')
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabForms"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekPms).slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize),
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullName",
      "label": "姓名",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.gender, 'C017', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "idNumber",
      "label": "身份证号（军官证号）",
      "width": "270",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职务",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.job, 'C022', _vm.dicMap, scope.row)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政治面貌",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.politicalStatus, 'C006', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文化程度",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.culture, 'C005', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称系列",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.professionalTitleSeries, 'C007', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称级别",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.titleLevel, 'C008', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否持有岗位培训资格证书",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type != 3) ? _c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.trainCertificateId)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.isTrainCertificate, 'C018', _vm.dicMap)) + "\n                            "), (scope.row.trainCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "持有出版专业职业资格证书情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.professionalCertificateId)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.certificateSituation, 'C009', _vm.dicMap)) + "\n                            "), (scope.row.professionalCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cellphone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }]
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }]
  }, [_vm._v("历史版本：")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historyJsonParams,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullName",
      "label": "姓名",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.gender, 'C017', _vm.dicMap)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "idNumber",
      "label": "身份证号（军官证号）",
      "width": "270",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职务",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.job, 'C022', _vm.dicMap, scope.row)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政治面貌",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.politicalStatus, 'C006', _vm.dicMap)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文化程度",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.culture, 'C005', _vm.dicMap)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称系列",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.professionalTitleSeries, 'C007', _vm.dicMap)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称级别",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.titleLevel, 'C008', _vm.dicMap)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否持有岗位培训资格证书",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type != 3) ? _c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.trainCertificateId)
            }
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("translate")(scope.row.isTrainCertificate, 'C018', _vm.dicMap)) + "\n                                "), (scope.row.trainCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "持有出版专业职业资格证书情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.professionalCertificateId)
            }
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("translate")(scope.row.certificateSituation, 'C009', _vm.dicMap)) + "\n                                "), (scope.row.professionalCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cellphone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])], 1), _vm._v(" "), (_vm.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.seekPms.no,
      "layout": "prev, pager, next",
      "page-count": _vm.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "pressComDiag",
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": function($event) {
        _vm.urlCreate('close')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgShowUrl,
      "width": "100%",
      "alt": ""
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("人数统计")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("岗位培训合格证书持有统计")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("出版专业职业资格证书持有情况统计")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("岗位类别")]), _vm._v(" "), _c('td', [_vm._v("人员数（人）")]), _vm._v(" "), _c('td', [_vm._v("持证人数")]), _vm._v(" "), _c('td', [_vm._v("占比")]), _vm._v(" "), _c('td', [_vm._v("中级以上")]), _vm._v(" "), _c('td', [_vm._v("占比")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c13bda8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceTab/table8.vue
// module id = 1719
// module chunks = 1